import {
    LISTAR_CATTIPOORDENCOMPRAS,
} from '../../types'


export default (state, action) => {
    switch (action.type){
        case LISTAR_CATTIPOORDENCOMPRAS:
            return{
                ...state, 
                tiposOrdenCompra: action.payload
            }
        default:
            return state
    }
        
}